
            import { lazy } from "react";

export const AdminHeader = lazy(() => import("./AdminHeader"));

            